import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { Guid } from "guid-typescript";
import Swal from "sweetalert2";
import { AssetMasterModule } from "@/store/modules/asset.module";
import Switches from "vue-switches";
import simplebar from "simplebar-vue";
import Loader from "../../../components/widgets/loader.vue";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { AssetAssignmentModel } from "@/store/models/asset/assetAssignmentDTO";
import { interpret } from "xstate";
import assetManagerMachine from "./machines/AssetManagerMachine";
import DeleteComponent from "@/components/deleteComponent.vue";
import { Constant } from "@/store/constant";
/**
 * Listing Employee Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let Assets = /** @class */ (() => {
    let Assets = class Assets extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.newSearchByAssetName = null;
            this.searchByAssetStatus = null;
            this.searchByAssetType = null;
            this.repairSwitch = false;
            this.assetDeleteModal = false;
            this.showLookupModal = false;
            this.searchLookupEmployee = "";
            this.selectedEmployeeId = "";
            this.showRemoveAssignmentModal = false;
            this.emptyGuid = Guid.createEmpty();
            this.assetAssign = new AssetAssignmentModel();
            this.isPageDirty = false;
            this.title = "Asset Manager";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Manager",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.isPageLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.columns = [
                {
                    field: "icon",
                    label: "",
                    tdClass: "asset-icon",
                    sortable: false,
                },
                {
                    field: "assetCode",
                    label: "Asset Code",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        autoComplete: "off",
                        placeholder: "Asset Code",
                    },
                },
                {
                    field: "assetType",
                    label: "Asset Type",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        autoComplete: "off",
                        placeholder: "Asset Type",
                    },
                },
                {
                    field: "category",
                    label: "Category",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        autoComplete: "off",
                        placeholder: "Asset Category",
                    },
                },
                {
                    field: "configuration",
                    label: "Configuration",
                    sortable: false,
                },
                {
                    field: "employeeName",
                    label: "Assigned To",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        autoComplete: "off",
                        placeholder: "Assigned To",
                    },
                },
                {
                    field: "assetLocationName",
                    label: "Asset Location",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "assetStatus",
                    label: "Status",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    tdClass: "employee-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "name",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.initialSortBy = {
                field: "name",
                type: "asc",
            };
            this.totalCount = 0;
            //   MACHINE
            this.machine = assetManagerMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        // METHODS
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.isPageDirty = false;
            AssetMasterModule.AssignSearchParams(searchData);
            this.machineService.send({ type: "GETTING_ASSET", searchData: searchData });
        }
        GenerateAssetsAsExcel() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.isPageLoading = true;
            this.machineService.send({
                type: "DOWNLOAD_ASSET_EXCEL",
                searchData: searchData,
            });
        }
        clearFilter() {
            this.repairSwitch = false;
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        //Lifecycle
        get rows() {
            return AssetMasterModule.assets;
        }
        get assetsData() {
            return AssetMasterModule.getAssetData;
        }
        get assignedAssets() {
            return AssetMasterModule.assetAssignment;
        }
        get assetStatusCode() {
            return AssetMasterModule.assetStatus.map((x) => ({ value: x.id, text: x.code }));
        }
        get assetLocations() {
            return AssetMasterModule.assetLocations.map((x) => ({ value: x.id, text: x.value }));
        }
        get employeeList() {
            return AssetMasterModule.getEmployeeData;
        }
        get totalAssets() {
            return AssetMasterModule.totalAssets;
        }
        showAssetDeleteModal(assetId, statustypeId, repairStatus) {
            this.assetId = assetId;
            const assetStatusMessages = {
                [Constant.AssetStatus.Assigned()]: "This asset is currently assigned. You can proceed with deletion once the assignment is revoked.",
                [Constant.AssetStatus.Repair()]: "Asset cannot be deleted since it is in Repair status",
                [Constant.AssetStatus.Scrap()]: "Asset cannot be deleted since it is in Scrap status",
                [Constant.AssetStatus.Disposed()]: "Asset cannot be deleted since it is in Disposed status",
            };
            if (repairStatus !== true && statustypeId === Constant.AssetStatus.InStore()) {
                const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
                this.machineService.send({ type: "DELETE_ASSET", ispageChanged: isPageChanged });
            }
            else if (assetStatusMessages[statustypeId]) {
                Swal.fire({
                    text: assetStatusMessages[statustypeId],
                    icon: "warning",
                    confirmButtonColor: "#34c38f",
                }).then(() => { });
            }
        }
        confirmDelete() {
            this.machineService.send({ type: "DELETING_ASSET", assetId: this.assetId });
            this.loadItems();
        }
        cancelDelete() {
            this.machineService.send({ type: "CANCEL_MODAL" });
        }
        backToAsset() {
            this.machineService.send({ type: "CLOSE_MODAL" });
            this.searchLookupEmployee = "";
            AssetMasterModule.ClearEmployeeData();
        }
        clearAssetLookupData() {
            this.searchLookupEmployee = "";
            AssetMasterModule.ClearEmployeeData();
        }
        showModal(assetId) {
            let isPageChanged = this.isAnyFilterApplied && this.rows.length === 1 && this.serverParams.page !== 1;
            this.machineService.send({ type: "ASSIGN_ASSET", ispageChanged: isPageChanged });
            this.selectedEmployeeId = null;
            this.assetId = assetId;
        }
        showModalForRemove(assetId) {
            let isPageChanged = this.isAnyFilterApplied && this.rows.length === 1 && this.serverParams.page !== 1;
            this.assetId = assetId;
            this.machineService.send({ type: "REMOVE_ASSIGNED_ASSET", ispageChanged: isPageChanged });
        }
        employeeRecordClick(employeeId) {
            this.selectedEmployeeId = employeeId;
            this.assetAssign.assetId = this.assetId;
            this.assetAssign.employeeId = employeeId;
        }
        confirmAssignAsset() {
            if (this.selectedEmployeeId != null) {
                this.machineService.send({
                    type: "ASSIGNING_ASSET",
                    payLoad: this.assetAssign,
                });
                this.searchLookupEmployee = "";
                this.employeeList.length = 0;
            }
        }
        removeAssetAssignment() {
            this.machineService.send({
                type: "REMOVING_ASSIGNING_ASSET",
                assetId: this.assetId,
            });
        }
        searchEmployeeDataByFilter() {
            if (this.searchLookupEmployee.length > 0) {
                this.machineService.send({
                    type: "SEARCH",
                    str: this.searchLookupEmployee,
                });
            }
            else {
                AssetMasterModule.ClearEmployeeData();
                this.searchLookupEmployee = null;
                this.machineService.send({
                    type: "SEARCH",
                    str: this.searchLookupEmployee,
                });
            }
        }
        onRowClick(params) {
            this.$router.push({ name: "ViewAsset", params: { assetId: params.row.id } });
        }
        clearEmployeeLookupData() {
            this.searchLookupEmployee = "";
            AssetMasterModule.ClearEmployeeData();
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.gridParams.columnFilters.forEach((item) => {
                    this.isPageDirty = true;
                    gridColumns[item.name] = item.value;
                });
            }
        }
        initialize() {
            var value = AssetMasterModule.searchParams;
            if (value != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                if (value.columnFilters.length > 0) {
                    value.columnFilters.forEach((item) => {
                        this.serverParams.columnFilters[item.name] = item.value;
                    });
                }
                this.initialSortBy = value.sort;
            }
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "EditAsset" && from.name != "ViewAsset") {
                AssetMasterModule.ClearSearchParams();
            }
            next();
        }
        get gridParams() {
            return AssetMasterModule.searchParams;
        }
        get excel() {
            return AssetMasterModule.ExportDataAssets;
        }
        get canEditAssetTypeProperties() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanEditAssetTypeProperties());
        }
        get canEditAssetDetails() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanEditAssetDetails());
        }
        get canViewAsset() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanView());
        }
        get canAddAsset() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanAdd());
        }
        get canAssignAsset() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanAssignAsset());
        }
        get canDeleteAsset() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanDelete());
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (state.matches("gettingAssets") && previousState.matches("assignFilters")) {
                    this.assignColumnFilters();
                }
                if (this.state.matches("loadedAssets") && previousState.matches("gettingAssets")) {
                    this.$bvModal.hide("employee-lookup");
                    this.totalCount = this.totalAssets;
                    this.isGridLoading = false;
                    var itemTypeColumn = this.columns.find((x) => x.field == "assetStatus");
                    if (itemTypeColumn && itemTypeColumn.filterOptions.filterDropdownItems.length == 0) {
                        itemTypeColumn.filterOptions.filterDropdownItems = this.assetStatusCode;
                    }
                    var assetLocationColumn = this.columns.find((x) => x.field == "assetLocationName");
                    if (assetLocationColumn && assetLocationColumn.filterOptions.filterDropdownItems.length == 0) {
                        assetLocationColumn.filterOptions.filterDropdownItems = this.assetLocations;
                    }
                }
                if (this.state.matches("assignAsset")) {
                    this.$bvModal.show("employee-lookup");
                }
                if (this.state.matches("loadedAssets") && previousState.matches("assignAsset")) {
                    this.$bvModal.hide("employee-lookup");
                }
                if ((this.state.matches("gettingAssets") && previousState.matches("deletingAsset")) ||
                    (this.state.matches("gettingAssets") && previousState.matches("removingAssignAsset")) ||
                    (this.state.matches("gettingAssets") && previousState.matches("assigningAsset"))) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
                if (this.state.matches("loadedAssets") || this.state.matches("loadedRepairAssets"))
                    if (previousState.matches("downloadAssetsAsExcel")) {
                        this.isPageLoading = true;
                        const blob = new Blob([this.excel], {
                            type: "application/vnd.ms-excel",
                        });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.download = `Assets.xlsx`;
                        link.click();
                        this.isPageLoading = false;
                    }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Assets = __decorate([
        Component({
            name: "Assets",
            components: {
                Layout,
                PageHeader,
                Switches,
                simplebar,
                Loader,
                SectionLoader,
                EcGrid,
                DeleteComponent,
            },
        })
    ], Assets);
    return Assets;
})();
export default Assets;
